module.exports = __webpack_public_path__ + "static/media/8762.5acea47d.png";